<ng-container *ngIf="!fail(); else templateFail">
    <ng-content></ng-content>
</ng-container>
<ng-template #templateFail>
    <ng-content select="[fail]"></ng-content>
</ng-template>